module.exports = __webpack_public_path__ + "img/subBanner12.9e508de7.png";